module.exports = __webpack_public_path__ + "static/media/menuChart.7ddd2582.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuChart.svg
// module id = 465
// module chunks = 0